module.exports = __webpack_public_path__ + "static/media/comment.4d950790.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/comment.svg
// module id = 38
// module chunks = 0